<template>
    <div class="finalizacao-container">
      <!-- ✅ HEADER MODERNO -->
      <div class="modern-header">
        <div class="header-wrapper">
          <div class="header-left">
      
            <div class="title-section">
              <h1 class="main-title">Finalizar Ordem</h1>
             </div>
          </div>
           
        </div>
      </div>
  
      <!-- ✅ CONTAINER PRINCIPAL -->
      <v-container fluid class="main-container">
        <v-row justify="center">
          <v-col cols="12" lg="10" xl="8">
  
            <!-- ✅ STEPPER VISUAL (DESKTOP/TABLET) -->
            <v-stepper 
              v-if="!isMobile" 
              v-model="currentStep" 
              class="elevation-2 stepper-modern"
              alt-labels
            >
              <v-stepper-header>
                <v-stepper-item 
                  :complete="currentStep > 1" 
                  :value="1"
                  color="primary"
                >
                  <template v-slot:icon>
                    <v-icon>mdi-magnify</v-icon>
                  </template>
                  Buscar Ordem
                </v-stepper-item>
                
                <v-divider></v-divider>
                
                <v-stepper-item 
                  :complete="currentStep > 2" 
                  :value="2"
                  color="primary"
                >
                  <template v-slot:icon>
                    <v-icon>mdi-clipboard-check</v-icon>
                  </template>
                  Verificar Dados
                </v-stepper-item>
                
                <v-divider></v-divider>
                
                <v-stepper-item 
                  :complete="currentStep > 3" 
                  :value="3"
                  color="primary"
                >
                  <template v-slot:icon>
                    <v-icon>mdi-chart-line</v-icon>
                  </template>
                  Produção Real
                </v-stepper-item>
                
                <v-divider></v-divider>
                
                <v-stepper-item 
                  :value="4"
                  color="success"
                >
                  <template v-slot:icon>
                    <v-icon>mdi-check-circle</v-icon>
                  </template>
                  Finalizar
                </v-stepper-item>
              </v-stepper-header>
            </v-stepper>
  
            <!-- ✅ PROGRESS BAR (MOBILE) -->
            <div v-if="isMobile" class="mobile-progress">
              <div class="progress-info">
                <span class="step-text">Etapa {{ currentStep }} de 4</span>
                <span class="step-name">{{ getStepName(currentStep) }}</span>
              </div>
              <v-progress-linear 
                :model-value="(currentStep / 4) * 100" 
                color="success"
                height="6"
                rounded
                class="mt-2"
              ></v-progress-linear>
            </div>
  
            <!-- ✅ FORMULÁRIO PRINCIPAL -->
            <v-card class="form-card" elevation="3">
              <v-card-text class="form-content">
  
                <!-- ETAPA 1: BUSCAR ORDEM -->
                <div v-show="currentStep === 1" class="step-content">
               
  
                  <!-- CARD DE BUSCA MODERNO -->
                  <v-card class="search-card" elevation="0" variant="tonal" color="primary">
                    <v-card-text class="pa-6">
                      <div class="search-header mb-4">
                        <v-icon color="primary" size="24" class="mr-2">mdi-database-search</v-icon>
                        <span class="search-title">Localizar Ordem de Produção</span>
                      </div>
                      
                      <v-row class="search-inputs">
                        <v-col cols="12" sm="4">
                          <v-text-field
                            v-model="searchId"
                            label="ID Cadastro"
                            variant="filled"
                            density="comfortable"
                            prepend-inner-icon="mdi-identifier"
                            @keyup.enter="buscarOrdem"
                            :loading="loading"
                            class="modern-input"
                            type="number"
                            hide-details
                            clearable
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4">
                          <v-text-field
                            v-model="searchPedido"
                            label="ID do Pedido"
                            variant="filled"
                            density="comfortable"
                            prepend-inner-icon="mdi-file-document"
                            @keyup.enter="buscarOrdem"
                            :loading="loading"
                            class="modern-input"
                            type="number"
                            hide-details
                            clearable
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4">
                          <v-text-field
                            v-model="searchOrdem"
                            label="Ordem SAP"
                            variant="filled"
                            density="comfortable"
                            prepend-inner-icon="mdi-format-list-numbered"
                            @keyup.enter="buscarOrdem"
                            :loading="loading"
                            class="modern-input"
                            type="number"
                            hide-details
                            clearable
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <div class="search-actions mt-4">
                        <v-btn
                          @click="buscarOrdem"
                          color="primary"
                          variant="elevated"
                          size="large"
                          :loading="loading"
                          :disabled="!searchId && !searchPedido && !searchOrdem"
                          class="search-btn"
                          block
                        >
                          <v-icon start>mdi-magnify</v-icon>
                          Buscar Ordem
                        </v-btn>
                        <v-btn
                          v-if="searchPedido"
                          class="mt-3"
                          block
                          color="success"
                          variant="outlined"
                          size="large"
                          :disabled="loading"
                          @click="abrirPreviewPedido(searchPedido)"
                        >
                          <v-icon start>mdi-check-all</v-icon>
                          Finalizar todas as ordens do pedido
                        </v-btn>
                      </div>
                    </v-card-text>
                  </v-card>
  
                  <!-- RESULTADOS DA BUSCA -->
                  <div v-if="ordensEncontradas.length > 0" class="results-section mt-6">
                    <div class="results-header">
                      <v-icon color="success" class="mr-2">mdi-check-circle</v-icon>
                      <span class="results-title">{{ ordensEncontradas.length }} ordem(ns) encontrada(s)</span>
                    </div>
                    
                    <div class="orders-grid">
                      <v-card 
                        v-for="ordem in ordensEncontradas" 
                        :key="ordem.id"
                        class="order-card"
                        elevation="2"
                        @click="selecionarOrdem(ordem)"
                        hover
                      >
                        <div class="order-header">
                          <div class="order-id">
                            <v-icon color="primary" size="20">mdi-identifier</v-icon>
                            <span class="id-text">#{{ ordem.id }}</span>
                          </div>
                          <v-chip 
                            :color="getStatusColor(ordem.status_dashboard)"
                            size="small"
                            variant="elevated"
                          >
                            {{ ordem.status_dashboard || 'N/A' }}
                          </v-chip>
                        </div>
                        
                        <div class="order-content">
                          <div class="order-info">
                            <div class="info-row">
                              <v-icon size="16" color="grey-darken-1">mdi-file-document</v-icon>
                              <span>Pedido: {{ ordem.id_pedido || 'N/A' }}</span>
                            </div>
                            <div class="info-row" v-if="ordem.id_ordem">
                              <v-icon size="16" color="grey-darken-1">mdi-format-list-numbered</v-icon>
                              <span>SAP: {{ ordem.id_ordem }}</span>
                            </div>
                            <div class="info-row">
                              <v-icon size="16" color="grey-darken-1">mdi-package-variant</v-icon>
                              <span>Qtd: {{ ordem.quantidade || 'N/A' }}</span>
                            </div>
                          </div>
                          
                          <div class="order-action">
                            <v-btn
                              color="success"
                              variant="elevated"
                              size="small"
                              block
                            >
                              <v-icon start size="16">mdi-cursor-pointer</v-icon>
                              Selecionar
                            </v-btn>
                          </div>
                        </div>
                      </v-card>
                    </div>
                  </div>
                </div>
  
                <!-- ETAPA 2: VERIFICAR DADOS -->
                <div v-show="currentStep === 2" class="step-content">
                  <div class="step-header">
                    <v-icon class="step-icon" color="primary">mdi-clipboard-check</v-icon>
                    <h2 class="step-title">Verificar Dados da Ordem</h2>
                  </div>

                  <div v-if="ordemSelecionada" class="verification-section">
                    <!-- CARD PRINCIPAL DA ORDEM -->
                    <v-card class="order-verification-card" elevation="3">
                      <div class="card-header">
                        <div class="header-left">
                          <v-avatar color="primary" size="48">
                            <v-icon color="white" size="24">mdi-package-variant</v-icon>
                          </v-avatar>
                          <div class="header-info">
                            <h3 class="order-title">Ordem #{{ ordemSelecionada.id }}</h3>
                            <p class="order-subtitle">Pedido #{{ ordemSelecionada.id_pedido }}</p>
                          </div>
                        </div>
                        <v-chip 
                          :color="getStatusColor(ordemSelecionada.status_dashboard)"
                          size="large"
                          variant="elevated"
                        >
                          {{ ordemSelecionada.status_dashboard }}
                        </v-chip>
                      </div>

                      <v-divider></v-divider>

                      <v-card-text class="pa-6">
                        <div class="details-grid">
                          <div class="detail-group">
                            <div class="group-title">
                              <v-icon color="primary" size="20">mdi-information</v-icon>
                              <span>Informações Básicas</span>
                            </div>
                            <div class="detail-items">
                              <div class="detail-row">
                                <span class="detail-label">ID Cadastro:</span>
                                <span class="detail-value">#{{ ordemSelecionada.id }}</span>
                              </div>
                              <div class="detail-row">
                                <span class="detail-label">ID Pedido:</span>
                                <span class="detail-value">#{{ ordemSelecionada.id_pedido }}</span>
                              </div>
                              <div class="detail-row" v-if="ordemSelecionada.id_ordem">
                                <span class="detail-label">Ordem SAP:</span>
                                <span class="detail-value">{{ ordemSelecionada.id_ordem }}</span>
                              </div>
                            </div>
                          </div>

                          <div class="detail-group">
                            <div class="group-title">
                              <v-icon color="success" size="20">mdi-cog</v-icon>
                              <span>Produção</span>
                            </div>
                            <div class="detail-items">
                              <div class="detail-row">
                                <span class="detail-label">Modelo:</span>
                                <span class="detail-value">{{ ordemSelecionada.modelo?.descricao || 'N/A' }}</span>
                              </div>
                              <div class="detail-row">
                                <span class="detail-label">Quantidade:</span>
                                <span class="detail-value highlight">{{ ordemSelecionada.quantidade }} unidades</span>
                              </div>
                              <div class="detail-row">
                                <span class="detail-label">Prioridade:</span>
                                <v-chip 
                                  :color="getPrioridadeColor(ordemSelecionada.prioridade)"
                                  size="small"
                                >
                                  {{ ordemSelecionada.prioridade }}
                                </v-chip>
                              </div>
                            </div>
                          </div>

                          <div class="detail-group">
                            <div class="group-title">
                              <v-icon color="info" size="20">mdi-calendar</v-icon>
                              <span>Datas</span>
                            </div>
                            <div class="detail-items">
                              <div class="detail-row">
                                <span class="detail-label">Criação:</span>
                                <span class="detail-value">{{ formatDate(ordemSelecionada.data_lancamento) }}</span>
                              </div>
                              <div class="detail-row" v-if="ordemSelecionada.data_inicio">
                                <span class="detail-label">Início:</span>
                                <span class="detail-value">{{ formatDate(ordemSelecionada.data_inicio) }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </v-card-text>
                    </v-card>

                    <!-- AÇÕES -->
                    <div class="verification-actions">
                      <v-btn
                        v-if="ordemSelecionada.id_pedido"
                        color="success"
                        variant="outlined"
                        size="large"
                        :disabled="loading"
                        @click="abrirPreviewPedido(ordemSelecionada.id_pedido)"
                      >
                        <v-icon start>mdi-check-all</v-icon>
                        Finalizar todas as ordens do pedido
                      </v-btn>
                      <v-btn
                        @click="voltarEtapa"
                        variant="outlined"
                        size="large"
                        color="grey"
                      >
                        <v-icon start>mdi-arrow-left</v-icon>
                        Voltar
                      </v-btn>
                      <v-btn
                        @click="proximaEtapa"
                        color="success"
                        variant="elevated"
                        size="large"
                      >
                        <v-icon start>mdi-check-circle</v-icon>
                        Confirmar e Continuar
                      </v-btn>
                    </div>
                  </div>
                </div>
  
                <!-- ETAPA 3: FINALIZAÇÃO SIMPLIFICADA -->
                <div v-show="currentStep === 3" class="step-content">
                  <div class="step-header">
                    <v-icon class="step-icon" color="success">mdi-check-circle</v-icon>
                    <h2 class="step-title">Finalizar Ordem de Produção</h2>
                  </div>

                  <!-- RESUMO DA ORDEM -->
                  <v-card class="finalization-summary" elevation="2" variant="tonal" color="primary">
                    <v-card-text class="pa-6">
                      <div class="summary-header">
                        <v-icon color="primary" size="32">mdi-package-variant</v-icon>
                        <div class="summary-info">
                          <h3 class="summary-title">Ordem #{{ ordemSelecionada?.id }}</h3>
                          <p class="summary-subtitle">{{ ordemSelecionada?.cliente?.nome || 'Cliente não informado' }}</p>
                        </div>
                      </div>
                      
                      <v-divider class="my-4"></v-divider>
                      
                      <div class="summary-details">
                        <div class="detail-item">
                          <span class="detail-label">Modelo:</span>
                          <span class="detail-value">{{ ordemSelecionada?.modelo?.descricao || 'N/A' }}</span>
                        </div>
                        <div class="detail-item">
                          <span class="detail-label">Quantidade:</span>
                          <span class="detail-value">{{ ordemSelecionada?.quantidade }} unidades</span>
                        </div>
                        <div class="detail-item">
                          <span class="detail-label">Pedido:</span>
                          <span class="detail-value">#{{ ordemSelecionada?.id_pedido }}</span>
                        </div>
                        <div class="detail-item" v-if="ordemSelecionada?.id_ordem">
                          <span class="detail-label">SAP:</span>
                          <span class="detail-value">{{ ordemSelecionada?.id_ordem }}</span>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>

                  <!-- FORMULÁRIO SIMPLIFICADO -->
                  <v-card class="finalization-form mt-4" elevation="2">
                    <v-card-text class="pa-6">
                      <div class="form-header mb-4">
                        <v-icon color="success" class="mr-2">mdi-calendar-check</v-icon>
                        <span class="form-title">Informar Data de Finalização</span>
                      </div>
                      
                      <v-row>
                        <v-col cols="12" md="6">
                          <v-text-field
                            v-model="dataFinalizacao"
                            label="Data de Finalização"
                            variant="filled"
                            type="date"
                            :rules="[rules.required]"
                            prepend-inner-icon="mdi-calendar-check"
                            hint="Informe a data de finalização da ordem"
                            persistent-hint
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-card class="status-info" variant="tonal" color="success">
                            <v-card-text class="text-center">
                              <v-icon color="success" size="32">mdi-check-circle</v-icon>
                              <div class="status-text">
                                <strong>Status Final:</strong><br>
                                CONCLUÍDA
                              </div>
                              <small class="text-caption">Será definido automaticamente</small>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>

                  <!-- AÇÕES -->
                  <div class="finalization-actions">
                    <v-btn
                      @click="voltarEtapa"
                      variant="outlined"
                      size="large"
                      color="grey"
                    >
                      <v-icon start>mdi-arrow-left</v-icon>
                      Voltar
                    </v-btn>
                    <v-btn
                      @click="finalizarOrdem"
                      color="success"
                      variant="elevated"
                      size="large"
                      :loading="loading"
                      :disabled="!dataFinalizacao"
                    >
                      <v-icon start>mdi-check-circle</v-icon>
                      Finalizar Ordem
                    </v-btn>
                  </div>
                </div>
  
                <!-- ETAPA 4: FINALIZAR -->
                <div v-show="currentStep === 4" class="step-content">
                  <div class="step-header">
                    <v-icon class="step-icon" color="success">mdi-check-circle</v-icon>
                    <h2 class="step-title">Confirmar Finalização</h2>
                  </div>
  
                  <!-- RESUMO FINAL -->
                  <v-card class="summary-card" variant="tonal" color="success">
                    <v-card-title>
                      <v-icon start>mdi-clipboard-check</v-icon>
                      Resumo da Finalização
                    </v-card-title>
                    <v-card-text>
                      <v-row>
                        <v-col cols="12" md="6">
                          <h4 class="summary-section">Ordem de Produção</h4>
                          <div class="summary-item">
                            <strong>ID:</strong> {{ ordemSelecionada?.id }}
                          </div>
                          <div class="summary-item">
                            <strong>Pedido:</strong> {{ ordemSelecionada?.id_pedido }}
                          </div>
                          <div class="summary-item">
                            <strong>Modelo:</strong> {{ ordemSelecionada?.modelo?.nome }}
                          </div>
                          <div class="summary-item">
                            <strong>Cliente:</strong> {{ ordemSelecionada?.cliente?.nome }}
                          </div>
                        </v-col>
                        
                        <v-col cols="12" md="6">
                          <h4 class="summary-section">Produção Realizada</h4>
                          <div class="summary-item">
                            <strong>Quantidade:</strong> {{ producaoReal.quantidade_produzida }} / {{ ordemSelecionada?.quantidade }}
                          </div>
                          <div class="summary-item">
                            <strong>Tempo:</strong> {{ producaoReal.tempo_real }}h / {{ ordemSelecionada?.tempo }}h
                          </div>
                          <div class="summary-item">
                            <strong>Status Final:</strong> {{ getStatusText(producaoReal.status_final) }}
                          </div>
                          <div class="summary-item">
                            <strong>Período:</strong> {{ formatDateShort(producaoReal.data_inicio) }} até {{ formatDateShort(producaoReal.data_conclusao) }}
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
  
                  <!-- ALERTAS E VALIDAÇÕES -->
                  <v-alert
                    v-if="alertas.length > 0"
                    type="warning"
                    class="mt-4"
                    variant="tonal"
                  >
                    <div class="alert-title">Atenção:</div>
                    <ul class="alert-list">
                      <li v-for="alerta in alertas" :key="alerta">{{ alerta }}</li>
                    </ul>
                  </v-alert>
                </div>
  
              </v-card-text>
  
              <!-- ✅ NAVEGAÇÃO RESPONSIVA -->
              <v-card-actions class="navigation-actions">
                <v-btn
                  v-if="currentStep > 1"
                  @click="previousStep"
                  color="grey"
                  variant="outlined"
                  size="large"
                >
                  <v-icon start>mdi-chevron-left</v-icon>
                  Anterior
                </v-btn>
  
                <v-spacer></v-spacer>
  
                <v-btn
                  @click="cancelar"
                  color="error"
                  variant="outlined"
                  size="large"
                  class="mr-3"
                >
                  <v-icon start>mdi-close</v-icon>
                  Cancelar
                </v-btn>
  
                <v-btn
                  v-if="currentStep < 4"
                  @click="nextStep"
                  color="primary"
                  variant="elevated"
                  size="large"
                  :disabled="!canProceed"
                >
                  Próximo
                  <v-icon end>mdi-chevron-right</v-icon>
                </v-btn>
  
                <v-btn
                  v-if="currentStep === 4"
                  @click="confirmarFinalizacao"
                  color="success"
                  variant="elevated"
                  size="large"
                  :disabled="!canFinalize"
                  :loading="finalizando"
                >
                  <v-icon start>mdi-check-circle</v-icon>
                  Finalizar Ordem
                </v-btn>
              </v-card-actions>
            </v-card>
  
          </v-col>
        </v-row>
      </v-container>
  
      <!-- ✅ MODAIS -->
      <v-dialog v-model="modalLote" max-width="900" scrollable :persistent="loading">
        <v-card>
          <v-card-title class="text-wrap">Prévia das ordens do pedido #{{ pedidoLote }}</v-card-title>
          <v-card-text>
            <p class="mb-3">Confira as ordens e desmarque as que não deseja finalizar. As selecionadas terão o status CONCLUÍDA, seguindo a finalização atual.</p>
            <v-text-field
              v-model="dataFinalizacaoLote"
              label="Data de Finalização"
              type="date"
              variant="outlined"
              :disabled="loading"
              :rules="[rules.required]"
              prepend-inner-icon="mdi-calendar-check"
            />
            <v-alert v-if="erroLote" type="error" variant="tonal" class="mb-3" role="alert">{{ erroLote }}</v-alert>
            <v-checkbox
              :model-value="todasOrdensLote"
              :indeterminate="idsLote.length > 0 && !todasOrdensLote"
              @update:model-value="selecionarTodasLote"
              label="Selecionar todas"
              :disabled="loading"
              hide-details
            />
            <p class="my-3" aria-live="polite">{{ idsLote.length }} de {{ ordensLote.length }} ordens selecionadas</p>
            <v-divider />
            <div v-for="ordem in ordensLote" :key="ordem.id" class="py-2">
              <v-checkbox v-model="idsLote" :value="ordem.id" :disabled="loading" hide-details>
                <template #label>
                  <div>
                    <strong>Ordem #{{ ordem.id }}</strong> · SAP: {{ ordem.id_ordem || 'N/A' }}
                    <div>{{ ordem.modelo?.descricao || 'Modelo não informado' }}</div>
                    <div class="text-body-2">{{ ordem.quantidade }} unidades · Status: {{ ordem.status_dashboard || 'N/A' }}</div>
                  </div>
                </template>
              </v-checkbox>
              <v-divider />
            </div>
          </v-card-text>
          <v-card-actions class="pa-4">
            <v-btn variant="outlined" :disabled="loading" @click="modalLote = false">Voltar</v-btn>
            <v-spacer />
            <v-btn color="success" variant="elevated" class="text-wrap" :loading="loading"
              :disabled="loading || !idsLote.length || !dataFinalizacaoLote"
              @click="finalizarOrdensLote">
              Finalizar {{ idsLote.length }} ordem(ns)
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Modal de Sucesso -->
      <v-dialog v-model="modalSucesso" max-width="500" persistent>
        <v-card class="success-dialog">
          <v-card-text class="text-center pa-8">
            <v-icon size="64" color="success" class="mb-4">mdi-check-circle</v-icon>
            <h2 class="success-title mb-4">Ordem Finalizada com Sucesso!</h2>
            <div class="ordem-number">
              <span class="number-label">Ordem de Produção</span>
              <div class="number-display">#{{ ordemSelecionada?.id }}</div>
            </div>
          </v-card-text>
          <v-card-actions class="justify-center pb-6">
            <v-btn @click="voltarInicio" color="success" size="large">
              Nova Finalização
            </v-btn>
            
          </v-card-actions>
        </v-card>
      </v-dialog>
  
      <!-- Modal de Loading -->
      <v-dialog v-model="loading" max-width="400" persistent>
        <v-card class="loading-dialog">
          <v-card-text class="text-center pa-8">
            <v-progress-circular 
              indeterminate 
              color="primary" 
              size="64"
              width="6"
              class="mb-4"
            ></v-progress-circular>
            <h3 class="loading-title">{{ mensagemLoading }}</h3>
          </v-card-text>
        </v-card>
      </v-dialog>
  
    </div>
  </template>
  
  <script>
import producaoService from '@/services/producaoService'
import { useToast } from "vue-toastification";
  
  const toast = useToast();
  
  export default {
    name: "FinalizarOrdemProducao",
    
    data() {
      return {
        currentStep: 1,
        loading: false,
        finalizando: false,
        mensagemLoading: "Carregando...",
        modalSucesso: false,
        modalLote: false,
        ordensLote: [],
        idsLote: [],
        pedidoLote: null,
        erroLote: '',
        dataFinalizacaoLote: null,
        
        // Busca
        searchId: "",
        searchPedido: "",
        searchOrdem: "",
        ordensEncontradas: [],
        ordemSelecionada: null,
        
        // Data de finalização
        dataFinalizacao: null,
        
        // Produção Real
        producaoReal: {
          quantidade_produzida: null,
          tempo_real: null,
          data_inicio: "",
          data_conclusao: "",
          status_final: "",
          observacoes_finalizacao: ""
        },
        
        // Opções
        statusOptions: [
          { text: "Concluída", value: "CONCLUIDA" },
          { text: "Concluída Parcial", value: "CONCLUIDA_PARCIAL" },
          { text: "Cancelada", value: "CANCELADA" },
          { text: "Pausada", value: "PAUSADA" }
        ],
        
        // Validações
        rules: {
          required: value => !!value || "Campo obrigatório",
          quantidadePositiva: value => value > 0 || "Quantidade deve ser maior que zero",
          tempoPositivo: value => value > 0 || "Tempo deve ser maior que zero",
          dataFim: value => {
            if (!value || !this.producaoReal.data_inicio) return true;
            return new Date(value) >= new Date(this.producaoReal.data_inicio) || "Data de conclusão deve ser posterior ao início";
          }
        }
      };
    },
  
    computed: {
      todasOrdensLote() {
        return this.ordensLote.length > 0 && this.idsLote.length === this.ordensLote.length;
      },
      isMobile() {
        return this.$vuetify?.display?.xs || window.innerWidth <= 600;
      },
  
      canProceed() {
        switch (this.currentStep) {
          case 1: return !!this.ordemSelecionada;
          case 2: return !!this.ordemSelecionada;
          case 3: return this.isProducaoValida();
          case 4: return this.canFinalize;
          default: return false;
        }
      },
  
      canFinalize() {
        return this.isProducaoValida() && this.producaoReal.status_final;
      },
  
      eficienciaQuantidade() {
        if (!this.ordemSelecionada?.quantidade || !this.producaoReal.quantidade_produzida) return 0;
        return Math.round((this.producaoReal.quantidade_produzida / this.ordemSelecionada.quantidade) * 100);
      },
  
      eficienciaTempo() {
        if (!this.ordemSelecionada?.tempo || !this.producaoReal.tempo_real) return 0;
        return Math.round((this.ordemSelecionada.tempo / this.producaoReal.tempo_real) * 100);
      },
  
      diasProducao() {
        if (!this.producaoReal.data_inicio || !this.producaoReal.data_conclusao) return 0;
        const inicio = new Date(this.producaoReal.data_inicio);
        const fim = new Date(this.producaoReal.data_conclusao);
        return Math.ceil((fim - inicio) / (1000 * 60 * 60 * 24));
      },
  
      statusPrazo() {
        if (!this.ordemSelecionada?.previsao_entrega || !this.producaoReal.data_conclusao) return "N/A";
        const previsao = new Date(this.ordemSelecionada.previsao_entrega);
        const conclusao = new Date(this.producaoReal.data_conclusao);
        
        if (conclusao <= previsao) return "No Prazo";
        const diasAtraso = Math.ceil((conclusao - previsao) / (1000 * 60 * 60 * 24));
        return `${diasAtraso} dias de atraso`;
      },
  
      alertas() {
        const alertas = [];
        
        if (this.eficienciaQuantidade < 100) {
          alertas.push("Quantidade produzida menor que o planejado");
        }
        
        if (this.eficienciaTempo < 80) {
          alertas.push("Tempo de produção muito acima do planejado");
        }
        
        if (this.statusPrazo.includes("atraso")) {
          alertas.push("Ordem finalizada com atraso");
        }
        
        return alertas;
      }
    },
  
    methods: {
      selecionarTodasLote(selecionar) {
        this.idsLote = selecionar ? this.ordensLote.map(ordem => ordem.id) : [];
      },
      async abrirPreviewPedido(pedido) {
        if (!pedido || this.loading) return;
        this.loading = true;
        this.mensagemLoading = 'Carregando todas as ordens do pedido...';
        this.erroLote = '';
        this.dataFinalizacaoLote = this.dataFinalizacao;
        try {
          const resposta = await producaoService.buscarOrdensParaFinalizacao({ id_pedido: pedido });
          this.ordensLote = resposta.data || [];
          this.pedidoLote = pedido;
          this.selecionarTodasLote(true);
          if (this.ordensLote.length) this.modalLote = true;
          else toast.warning('Nenhuma ordem encontrada para este pedido');
        } catch (error) {
          toast.error(error.message || 'Não foi possível carregar as ordens do pedido');
        } finally {
          this.loading = false;
        }
      },
      async finalizarOrdensLote() {
        if (this.loading || !this.idsLote.length || !this.dataFinalizacaoLote) return;
        // Usar a mesma finalização individual, inclusive data e status.
        const ids = [...this.idsLote];
        const concluidas = [];
        this.loading = true;
        this.erroLote = '';
        try {
          for (const id of ids) {
            this.mensagemLoading = `Finalizando ordem #${id} (${concluidas.length + 1} de ${ids.length})...`;
            const resultado = await producaoService.finalizarOrdem(id, this.dataFinalizacaoLote);
            if (resultado.status !== 'sucesso') throw new Error(resultado.message || `Erro ao finalizar ordem #${id}`);
            concluidas.push(id);
          }
          this.modalLote = false;
          this.resetarFormulario();
          toast.success(`${concluidas.length} ordem(ns) finalizada(s) com sucesso!`);
        } catch (error) {
          this.erroLote = `${concluidas.length} de ${ids.length} ordem(ns) finalizada(s). ${error.message || 'Não foi possível continuar a finalização'}. Confira as restantes e tente novamente.`;
        } finally {
          // Retirar os sucessos da prévia para não reenviá-los em uma nova tentativa.
          this.ordensLote = this.ordensLote.filter(ordem => !concluidas.includes(ordem.id));
          this.idsLote = this.idsLote.filter(id => !concluidas.includes(id));
          this.ordensEncontradas = this.ordensEncontradas.filter(ordem => !concluidas.includes(ordem.id));
          if (this.ordemSelecionada && concluidas.includes(this.ordemSelecionada.id)) {
            this.ordemSelecionada = null;
            this.currentStep = 1;
          }
          this.loading = false;
        }
      },
      getStepName(step) {
        const steps = {
          1: 'Buscar',
          2: 'Verificar',
          3: 'Produção',
          4: 'Finalizar'
        };
        return steps[step] || '';
      },
  
      nextStep() {
        if (this.canProceed && this.currentStep < 4) {
          this.currentStep++;
        }
      },
  
      previousStep() {
        if (this.currentStep > 1) {
          this.currentStep--;
        }
      },
  
      async buscarOrdem() {
        if (!this.searchId && !this.searchPedido && !this.searchOrdem) {
          toast.warning("Informe pelo menos um critério de busca");
          return;
        }

        this.loading = true;
        this.mensagemLoading = "Buscando ordem de produção...";

        try {
          const params = {};
          if (this.searchId) params.id = this.searchId;
          if (this.searchPedido) params.id_pedido = this.searchPedido;
          if (this.searchOrdem) params.id_ordem = this.searchOrdem;

          const response = await producaoService.buscarOrdensParaFinalizacao(params);
          this.ordensEncontradas = response.data || [];

          if (this.ordensEncontradas.length === 0) {
            toast.warning("Nenhuma ordem encontrada");
          } else if (this.ordensEncontradas.length === 1) {
            this.selecionarOrdem(this.ordensEncontradas[0]);
          }
        } catch (error) {
          console.error("Erro ao buscar ordem:", error);
          toast.error("Erro ao buscar ordem de produção");
        } finally {
          this.loading = false;
        }
      },
  
      selecionarOrdem(ordem) {
        this.ordemSelecionada = ordem;
        this.currentStep = 2;
        
        // Pré-preencher dados
        this.producaoReal.quantidade_produzida = ordem.quantidade;
        this.producaoReal.tempo_real = ordem.tempo;
      },
  
      isProducaoValida() {
        return this.producaoReal.quantidade_produzida > 0 &&
               this.producaoReal.tempo_real > 0 &&
               this.producaoReal.data_inicio &&
               this.producaoReal.data_conclusao;
      },
  
      async finalizarOrdem() {
        try {
          this.loading = true;
          this.mensagemLoading = "Finalizando ordem...";

          const resultado = await producaoService.finalizarOrdem(
            this.ordemSelecionada.id, 
            this.dataFinalizacao
          );

          if (resultado.status === 'sucesso') {
            this.modalSucesso = true;
            toast.success(resultado.message || 'Ordem finalizada com sucesso!');
          } else {
            throw new Error(resultado.message || 'Erro ao finalizar ordem');
          }

        } catch (error) {
          console.error('Erro ao finalizar ordem:', error);
          toast.error(error.message || 'Erro ao finalizar ordem de produção');
        } finally {
          this.loading = false;
        }
      },
  
      voltarInicio() {
        this.modalSucesso = false;
        this.resetarFormulario();
      },
  
      resetarFormulario() {
        this.currentStep = 1;
        this.searchId = "";
        this.searchPedido = "";
        this.searchOrdem = "";
        this.ordensEncontradas = [];
        this.ordemSelecionada = null;
        this.dataFinalizacao = null;
      },
  
      voltarEtapa() {
        if (this.currentStep > 1) {
          this.currentStep--;
        }
      },

      proximaEtapa() {
        if (this.currentStep < 3) {
          this.currentStep++;
        }
      },

      cancelar() {
        this.$router.go(-1);
      },

      verRelatorio() {
        this.$router.push({ 
          name: 'RelatorioProducao', 
          params: { id: this.ordemSelecionada.id } 
        });
      },
  
      // Métodos auxiliares
      getStatusColor(status) {
        const colors = {
          'EM_PRODUCAO': 'warning',
          'PAUSADA': 'orange',
          'CONCLUIDA': 'success',
          'CANCELADA': 'error',
          'PENDENTE': 'grey'
        };
        return colors[status] || 'grey';
      },
  
      getStatusIcon(status) {
        const icons = {
          'EM_PRODUCAO': 'mdi-cog',
          'PAUSADA': 'mdi-pause',
          'CONCLUIDA': 'mdi-check-circle',
          'CANCELADA': 'mdi-close-circle',
          'PENDENTE': 'mdi-clock'
        };
        return icons[status] || 'mdi-help-circle';
      },
  
      getPrioridadeColor(prioridade) {
        if (prioridade <= 2) return 'error';
        if (prioridade <= 4) return 'warning';
        return 'success';
      },
  
      getStatusText(status) {
        const texts = {
          'CONCLUIDA': 'Concluída',
          'CONCLUIDA_PARCIAL': 'Concluída Parcial',
          'CANCELADA': 'Cancelada',
          'PAUSADA': 'Pausada'
        };
        return texts[status] || status;
      },
  
      getAtrasoClass() {
        if (this.statusPrazo.includes("atraso")) return "text-error";
        if (this.statusPrazo === "No Prazo") return "text-success";
        return "";
      },
  
      formatDate(date) {
        if (!date) return "N/A";
        return new Date(date).toLocaleDateString('pt-BR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        });
      },
  
      formatDateShort(date) {
        if (!date) return "N/A";
        return new Date(date).toLocaleDateString('pt-BR');
      }
    }
  };
  </script>
  
  <style scoped>
  .verification-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-top: 24px;
  }

  .verification-actions .v-btn,
  .search-actions .v-btn {
    white-space: normal;
    height: auto !important;
    min-height: 48px;
    padding-top: 12px;
    padding-bottom: 12px;
  }

  @media (max-width: 600px) {
    .verification-actions .v-btn {
      width: 100%;
    }
  }
  /* Usar o mesmo CSS do template anterior com algumas adições específicas */
  
  /* ✅ VARIÁVEIS CSS */
  :root {
    --primary-color: #1976d2;
    --secondary-color: #424242;
    --success-color: #4caf50;
    --warning-color: #ff9800;
    --error-color: #f44336;
    --info-color: #2196f3;
    
    --border-radius: 12px;
    --border-radius-lg: 16px;
    --spacing-xs: 4px;
    --spacing-sm: 8px;
    --spacing-md: 16px;
    --spacing-lg: 24px;
    --spacing-xl: 32px;
    
    --shadow-sm: 0 2px 4px rgba(0,0,0,0.1);
    --shadow-md: 0 4px 12px rgba(0,0,0,0.15);
    --shadow-lg: 0 8px 24px rgba(0,0,0,0.2);
    
    --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }
  
  /* ✅ ESTILOS ESPECÍFICOS PARA FINALIZAÇÃO */
  
  .ordens-list {
    margin-top: var(--spacing-lg);
  }
  
  .list-title {
    font-size: 1.25rem;
    font-weight: 600;
    margin-bottom: var(--spacing-md);
    color: var(--secondary-color);
  }
  
  .ordem-item {
    margin-bottom: var(--spacing-md);
    cursor: pointer;
    transition: var(--transition);
    border-radius: var(--border-radius) !important;
  }
  
  .ordem-item:hover {
    transform: translateY(-2px);
    box-shadow: var(--shadow-md) !important;
    border-color: var(--primary-color) !important;
  }
  
  .ordem-info h4 {
    font-size: 1.125rem;
    font-weight: 600;
    margin: 0 0 4px 0;
    color: var(--secondary-color);
  }
  
  .ordem-details {
    border-radius: var(--border-radius) !important;
    margin-bottom: var(--spacing-lg);
  }
  
  .ordem-title {
    background: linear-gradient(135deg, var(--info-color) 0%, #1976d2 100%);
    color: white !important;
  }
  
  .info-group {
    margin-bottom: var(--spacing-md);
  }
  
  .info-title {
    font-size: 1.125rem;
    font-weight: 600;
    margin-bottom: var(--spacing-sm);
    color: var(--info-color);
    border-bottom: 2px solid rgba(33, 150, 243, 0.2);
    padding-bottom: var(--spacing-xs);
  }
  
  .info-item {
    padding: var(--spacing-xs) 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
  
  .info-item:last-child {
    border-bottom: none;
  }
  
  .observacoes-text {
    background: rgba(33, 150, 243, 0.05);
    padding: var(--spacing-md);
    border-radius: var(--border-radius);
    border-left: 4px solid var(--info-color);
    margin: 0;
  }
  
  .performance-card {
    border-radius: var(--border-radius) !important;
    border-left: 4px solid var(--success-color) !important;
  }
  
  .indicator {
    text-align: center;
    padding: var(--spacing-md);
    background: rgba(255, 255, 255, 0.8);
    border-radius: var(--border-radius);
    margin: var(--spacing-xs);
  }
  
  .indicator-value {
    font-size: 1.5rem;
    font-weight: 700;
    color: var(--success-color);
    line-height: 1;
  }
  
  .indicator-label {
    font-size: 0.75rem;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: var(--secondary-color);
    margin-top: var(--spacing-xs);
  }
  
  .summary-card {
    border-radius: var(--border-radius) !important;
    border-left: 4px solid var(--success-color) !important;
  }
  
  .summary-section {
    font-size: 1.125rem;
    font-weight: 600;
    margin-bottom: var(--spacing-sm);
    color: var(--success-color);
    border-bottom: 2px solid rgba(76, 175, 80, 0.2);
    padding-bottom: var(--spacing-xs);
  }
  
  .summary-item {
    padding: var(--spacing-xs) 0;
    border-bottom: 1px solid rgba(76, 175, 80, 0.1);
  }
  
  .summary-item:last-child {
    border-bottom: none;
  }
  
  .alert-title {
    font-weight: 600;
    margin-bottom: var(--spacing-sm);
  }
  
  .alert-list {
    margin: 0;
    padding-left: var(--spacing-lg);
  }
  
  .text-error {
    color: var(--error-color) !important;
  }
  
  .text-success {
    color: var(--success-color) !important;
  }
  
  /* ✅ RESPONSIVIDADE */
  @media (max-width: 600px) {
    .ordem-item .v-row {
      flex-direction: column;
      gap: var(--spacing-sm);
    }
    
    .indicator {
      margin: var(--spacing-xs) 0;
    }
    
    .indicator-value {
      font-size: 1.25rem;
    }
  }
  
  /* Reutilizar outros estilos do template anterior */
  .finalizacao-container {
    min-height: 100vh;
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
    padding: var(--spacing-md);
  }
  
  .page-header {
    background: linear-gradient(135deg, var(--success-color) 0%, #388e3c 100%);
    border-radius: var(--border-radius-lg);
    margin-bottom: var(--spacing-lg);
    box-shadow: var(--shadow-md);
  }
  
  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: var(--spacing-lg);
    color: white;
  }
  
  .header-title {
    display: flex;
    align-items: center;
    gap: var(--spacing-md);
  }
  
  .header-icon {
    background: rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    padding: var(--spacing-sm);
  }
  
  .title {
    font-size: clamp(1.5rem, 4vw, 2rem);
    font-weight: 600;
    margin: 0;
    letter-spacing: -0.025em;
  }
  
  .version-chip {
    background: rgba(255, 255, 255, 0.2) !important;
    color: white !important;
  }
  
  .main-container {
    max-width: 1200px;
    margin: 0 auto;
  }
  
  .stepper-modern {
    border-radius: var(--border-radius-lg) !important;
    margin-bottom: var(--spacing-lg);
    box-shadow: var(--shadow-sm) !important;
  }
  
  .mobile-progress {
    background: white;
    border-radius: var(--border-radius);
    padding: var(--spacing-md);
    margin-bottom: var(--spacing-lg);
    box-shadow: var(--shadow-sm);
  }
  
  .progress-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: var(--spacing-sm);
  }
  
  .step-text {
    font-weight: 600;
    color: var(--success-color);
  }
  
  .step-name {
    font-size: 0.875rem;
    color: var(--secondary-color);
  }
  
  .form-card {
    border-radius: var(--border-radius-lg) !important;
    box-shadow: var(--shadow-md) !important;
    overflow: hidden;
  }
  
  .form-content {
    padding: var(--spacing-xl) !important;
  }
  
  .step-content {
    min-height: 400px;
    animation: fadeInUp 0.5s ease-out;
  }
  
  .step-header {
    display: flex;
    align-items: center;
    gap: var(--spacing-md);
    margin-bottom: var(--spacing-xl);
    padding-bottom: var(--spacing-md);
    border-bottom: 2px solid #f0f0f0;
  }
  
  .step-icon {
    background: rgba(76, 175, 80, 0.1);
    border-radius: 50%;
    padding: var(--spacing-md);
  }
  
  .step-title {
    font-size: 1.5rem;
    font-weight: 600;
    color: var(--secondary-color);
    margin: 0;
  }
  
  .search-row {
    margin-bottom: var(--spacing-lg);
  }
  
  .search-field {
    transition: var(--transition);
  }
  
  .search-field:focus-within {
    transform: translateY(-2px);
  }
  
  .search-btn {
    height: 56px !important;
    font-weight: 600 !important;
    letter-spacing: 0.025em !important;
  }
  
  .navigation-actions {
    padding: var(--spacing-lg) var(--spacing-xl) !important;
    background: #fafafa;
    border-top: 1px solid #e0e0e0;
  }
  
  .success-dialog {
    border-radius: var(--border-radius-lg) !important;
    overflow: hidden;
    text-align: center;
  }
  
  .success-title {
    font-size: 1.5rem;
    font-weight: 600;
    color: var(--success-color);
  }
  
  .ordem.ordem-number {
  background: rgba(76, 175, 80, 0.1);
  border-radius: var(--border-radius);
  padding: var(--spacing-lg);
  margin: var(--spacing-lg) 0;
}

.number-label {
  display: block;
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--secondary-color);
  margin-bottom: var(--spacing-sm);
}

.number-display {
  font-size: 3rem;
  font-weight: 700;
  color: var(--success-color);
  line-height: 1;
}

.loading-dialog {
  border-radius: var(--border-radius-lg) !important;
  overflow: hidden;
}

.loading-title {
  font-size: 1.125rem;
  font-weight: 500;
  color: var(--secondary-color);
}

/* ✅ ANIMAÇÕES */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ✅ RESPONSIVIDADE ADICIONAL */
@media (max-width: 960px) {
  .header-content {
    padding: var(--spacing-md);
  }
  
  .form-content {
    padding: var(--spacing-lg) !important;
  }
}

@media (max-width: 600px) {
  .finalizacao-container {
    padding: var(--spacing-sm);
  }
  
  .header-content {
    flex-direction: column;
    gap: var(--spacing-md);
    text-align: center;
  }
  
  .form-content {
    padding: var(--spacing-md) !important;
  }
  
  .step-header {
    flex-direction: column;
    text-align: center;
    gap: var(--spacing-sm);
  }
  
  .navigation-actions {
    flex-direction: column;
    gap: var(--spacing-md);
  }
  
  .navigation-actions .v-btn {
    width: 100%;
  }
  
  .number-display {
    font-size: 2.5rem;
  }
}

@media (max-width: 480px) {
  .title {
    font-size: 1.25rem;
  }
  
  .step-title {
    font-size: 1.25rem;
  }
}

/* ✅ MODO ESCURO */
@media (prefers-color-scheme: dark) {
  .finalizacao-container {
    background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
  }
  
  .step-header {
    border-bottom-color: #404040;
  }
  
  .navigation-actions {
    background: #2d2d2d;
    border-top-color: #404040;
  }
}

/* ✅ ACESSIBILIDADE */
@media (prefers-reduced-motion: reduce) {
  * {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}

.v-btn:focus-visible,
.v-text-field:focus-within,
.ordem-item:focus-visible {
  outline: 2px solid var(--primary-color);
  outline-offset: 2px;
}

/* ✅ IMPRESSÃO */
@media print {
  .finalizacao-container {
    background: white !important;
    padding: 0 !important;
  }
  
  .navigation-actions,
  .header-content {
    display: none !important;
  }
}
</style>
